import { render, staticRenderFns } from "./InputFilter.vue?vue&type=template&id=0167477a&scoped=true&"
import script from "./InputFilter.vue?vue&type=script&lang=js&"
export * from "./InputFilter.vue?vue&type=script&lang=js&"
import style0 from "./InputFilter.vue?vue&type=style&index=0&id=0167477a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0167477a",
  null
  
)

export default component.exports